import axios from './axios'



// 订单列表
export function orderList(data){
    return axios.post(`commodity/order/queryOrderPage`,data)
}

// 获取所有订单
export function exportOrderData(data){
    return axios.post(`commodity/order/exportOrderData`,data)
}
// 订单详情
export function orderDetail(data){
    return axios.post(`commodity/order/queryOrderDetails`,data)
}
// 退款
export function refundOrder(data){
    return axios.post(`app/payment/orderRefund`,data)
}
// 售卖车
export function productcar(data){
    return axios.get(`kiosk/list`,data)
}



// 自主售货机订单展示
export function autoOrder(data){
    return axios.post(`commodity/order/selectVendingInfo`,data)
}

// 自助售货机退款
export function vendingRefund(data){
    return axios.post(`app/payment/vendingRefund`,data)
}


